import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import { Grid } from '@material-ui/core'
import { getManagementSoilsPracticesByForm } from '../../../../../../services/Elegibilidad/get'
// import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../../../context/EligibilityContext'

const Table399 = ({ idElegibilityForm }) => {
  // const { step } = useFormElegibilidad()
  const [state] = useEligibility()

  const [tableData, setTableData] = useState([])

  const getDataTable = async () => {
    try {
      const response = await getManagementSoilsPracticesByForm(
        idElegibilityForm,
      )
      if (response.Code === 200) {
        setTableData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const columns = [
    {
      title: 'Prácticas de adaptación',
      field: 'AdaptationPracticeDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'onAdd',
    },
    {
      title: 'Seleccione si se ha implementado antes en la MIPYME',
      field: 'PreviouslyImplemented',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
    },
    {
      title:
        '¿Cuántos hombres agricultores han implementado esta medida, dentro de la MIPYME?',
      field: 'Men',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },

      align: 'center',
    },
    {
      title:
        '¿Cuántas mujeres agricultoras han implementado esta medida, dentro de la MIPYME?',
      field: 'Women',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'center',
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',
              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              // toolbarButtonAlignment: 'left',

              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table399)
